import { twMerge } from "tailwind-merge"

interface RequiredProps {
  className?: string
}

const Required: React.FC<RequiredProps> = ({ className }) => {
  return <span className={twMerge("text-red-500", className)}>*</span>
}

export default Required
